import { defineMessages } from 'react-intl';

export const handlingUnitSectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Handling Units',
    id: 'RqgXiZ',
    description: 'Title of the handling units card in the freight details view',
  },
  unitLabel: {
    defaultMessage: 'Unit {number} - {packaging}',
    id: 'CH7Ue0',
    description: 'Label for a single handling unit, with its index and packaging type',
  },
  commodityLabel: {
    defaultMessage: 'Commodity {number}',
    id: 'Nbx6Yi',
    description: 'Label for a single commodity within a handling unit',
  },
  quantity: {
    defaultMessage: 'Quantity',
    id: 'MMCg8q',
    description: 'Label for the handling unit quantity measurement',
  },
  width: {
    defaultMessage: 'Width',
    id: 'UGNgKF',
    description: 'Label for the handling unit width measurement',
  },
  length: {
    defaultMessage: 'Length',
    id: '5Jdzy+',
    description: 'Label for the handling unit length measurement',
  },
  height: {
    defaultMessage: 'Height',
    id: 'p7nhbg',
    description: 'Label for the handling unit height measurement',
  },
  stackable: {
    defaultMessage: 'Stackable',
    id: '+zHBy6',
    description: 'Label for whether a handling unit is stackable',
  },
  stackableYes: {
    defaultMessage: 'Yes',
    id: '42D0EG',
    description: 'Value shown when a handling unit is stackable',
  },
  stackableNo: {
    defaultMessage: 'No',
    id: 'm2DR0a',
    description: 'Value shown when a handling unit is not stackable',
  },
  freightClass: {
    defaultMessage: 'Class',
    id: 'mjyDUx',
    description: 'Label for the commodity freight class measurement',
  },
  totalWeight: {
    defaultMessage: 'Total Weight',
    id: 'sE/qV2',
    description: 'Label for the commodity total weight measurement',
  },
  nmfcCode: {
    defaultMessage: 'NMFC Code',
    id: 'Z/DmsE',
    description: 'Label for the commodity NMFC code measurement',
  },
  pieceType: {
    defaultMessage: 'Piece',
    id: 'QFS6Py',
    description: 'Label for the commodity piece type measurement',
  },
  pieceQuantity: {
    defaultMessage: 'Piece Quantity',
    id: 'jMQenG',
    description: 'Label for the commodity number of pieces measurement',
  },
  dimensionValue: {
    defaultMessage: '{value} {unit}',
    id: 'eDeZKi',
    description: 'A dimension value followed by its unit abbreviation',
  },
  weightValue: {
    defaultMessage: '{value} {unit}',
    id: 'bj0Lyb',
    description: 'A weight value followed by its unit abbreviation',
  },
});
